import api from '../interceptors/interceptor';
import { API_ROUTES } from '../constants/apiRoutes';

export class EvaluationRepository {
  private static instance: EvaluationRepository;

  /**
   * Singleton pattern - ensure only one instance exists
   */
  public static getInstance(): EvaluationRepository {
    if (!EvaluationRepository.instance) {
      EvaluationRepository.instance = new EvaluationRepository();
    }
    return EvaluationRepository.instance;
  }

  public async getMetrics(): Promise<any> {
    return (await api.get(API_ROUTES.EVAL_METRICS))?.data;
  }

  public async createEvaluation(payload: any): Promise<any> {
    return (await api.post(API_ROUTES.EVAL_CREATE, payload))?.data;
  }

  public async getAllEvaluations(): Promise<any> {
    return (await api.get(API_ROUTES.EVAL_LIST))?.data;
  }

  public async getEvaluationById(id: string): Promise<any> {
    return (await api.get(API_ROUTES.EVAL_BY_ID(id)))?.data;
  }

  public async getEvaluationModels(evaluationId: string): Promise<any> {
    return (await api.get(API_ROUTES.EVAL_MODELS(evaluationId)))?.data;
  }

  public async getModelVersions(evaluationId: string, deploymentId: string): Promise<any> {
    return (await api.get(API_ROUTES.EVAL_MODEL_VERSIONS(evaluationId, deploymentId)))?.data;
  }

  public async getEvaluationRunResults(runId: string): Promise<any> {
    return (await api.get(API_ROUTES.EVAL_RUN_RESULTS(runId)))?.data;
  }
}
